<template>
	<div class="container">
		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<router-link :to="{ name: 'PCReDive'}" tag="li" class="breadcrumb-item">
					<a href="#">首頁</a>
				</router-link>
				<router-link :to="{ name: 'BattleReport'}" tag="li" class="breadcrumb-item">
					<a href="#">競技戰報(離線版)</a>
				</router-link>
			</ol>
		</nav>
		<!-- Modal -->
		<Loading v-if="isLoading" />
		<div class="modal fade" id="ExportOk" tabindex="-1" role="dialog" aria-labelledby="ExportOkLabel" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="ExportOkLabel">匯出連結</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						連結只會保存7天，需儲存請儲存當前瀏覽器。
						<a :href="exportNotice" target="_blank">{{exportNotice}}</a>
					</div>
					<div class="modal-footer">
						<button type="button" class="pcbtn" data-dismiss="modal">Close</button>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="SaveOk" tabindex="-1" role="dialog" aria-labelledby="SaveOkLabel" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="SaveOkLabel">儲存成功</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						儲存資料只會存在使用的瀏覽器中
					</div>
					<div class="modal-footer">
						<button type="button" class="pcbtn" data-dismiss="modal">Close</button>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="DeleteOk" tabindex="-1" role="dialog" aria-labelledby="DeleteOkLabel" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="DeleteOkLabel">刪除確認</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						確認刪除角色嗎?
					</div>
					<div class="modal-footer">
						<button type="button" class="pcbtn" data-dismiss="modal">Close</button>
						<button type="button" class="pcbtn danger" data-dismiss="modal" @click="deleteTeam">刪除</button>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="AddCharacter" tabindex="-1" role="dialog" aria-labelledby="AddCharacterTitle" aria-hidden="true">
			<div class="modal-dialog modal-xl modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="AddCharacterTitle">加入對戰紀錄</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="battleTeam-box item-box">
							<div class="step-wrapper">
								<div class="step" style="transform: translateX(0px);">
									<ol>
										<li><a style="left: -30px" class="selected">攻擊方</a></li>
										<li><a :class="{ selected: this.step2ball} " :style="clientWidth > 1000 ? 'left:47%': 'left:35%'">防守方</a></li>
										<li><a :class="{ selected: this.step3ball} " style="right:-23px">設定完成</a></li>
									</ol>
									<span style="transform: scaleX(0);" class="filling-line" :style="stepLineStyle"></span>
								</div>
							</div>
							<div class="battleTeam-content" :style="{'height' : objHeight}">
								<ol>
									<li class="selected" :style="step1BlockStyle" ref="setp1">
										<h2>攻擊方</h2>
										<h3 class="item-title">前衛</h3>
										<div class="d-flex flex-wrap mb-3 justify-content-center">
											<template v-for="(item,index) in unitList" :value="item" v-if="Number(item.search_area_width) < 300">
												<div class="p-1 armory-box battle-box">													
													<div class="armory-img-box gacha-item star3" :class="item.select ? '' : 'grayimg'" @click="joinTeam(item.unit_id,index,item.rarity,1)">
														<img :src="'/static/images/unit/icon_unit_'+ (Number(item.unit_id)+30) +'.png'" alt="">
													</div>
												</div>	
											</template>
										</div>
										<h3 class="item-title">中衛</h3>
										<div class="d-flex flex-wrap mb-3 justify-content-center">
											<template v-for="(item,index) in unitList" :value="item" v-if="Number(item.search_area_width) < 600 && Number(item.search_area_width) > 300">
												<div class="p-1 armory-box battle-box">													
													<div class="armory-img-box gacha-item star3" :class="item.select ? '' : 'grayimg'" @click="joinTeam(item.unit_id,index,item.rarity,1)">
														<img :src="'/static/images/unit/icon_unit_'+ (Number(item.unit_id)+30) +'.png'" alt="">
													</div>
												</div>	
											</template>
										</div>										
										<h3 class="item-title">後衛</h3>
										<div class="d-flex flex-wrap mb-3 justify-content-center">
											<template v-for="(item,index) in unitList" :value="item" v-if="Number(item.search_area_width) < 900 && Number(item.search_area_width) > 600">
												<div class="p-1 armory-box battle-box">													
													<div class="armory-img-box gacha-item star3" :class="item.select ? '' : 'grayimg'" @click="joinTeam(item.unit_id,index,item.rarity,1)">
														<img :src="'/static/images/unit/icon_unit_'+ (Number(item.unit_id)+30) +'.png'" alt="">
													</div>
												</div>	
											</template>
										</div>
										<div class="ok-box text-center my-3 py-1">
											<div class="pcbtn mr-3" data-dismiss="modal" aria-label="Close">取消</div>
											<div @click="nextStep(2)" class="pcbtn">下一步</div>
										</div>
									</li>
									<li :style="step2BlockStyle" ref="setp2">
										<h2>防守方</h2>
										<h3 class="item-title">前衛</h3>
										<div class="d-flex flex-wrap mb-3 justify-content-center">
											<template v-for="(item,index) in unitList" :value="item" v-if="Number(item.search_area_width) < 300">
												<div class="p-1 armory-box battle-box">													
													<div class="armory-img-box gacha-item star3" :class="item.select ? '' : 'grayimg'" @click="joinTeam(item.unit_id,index,item.rarity,2)">
														<img :src="'/static/images/unit/icon_unit_'+ (Number(item.unit_id)+30) +'.png'" alt="">
													</div>
												</div>	
											</template>
										</div>
										<h3 class="item-title">中衛</h3>
										<div class="d-flex flex-wrap mb-3 justify-content-center">
											<template v-for="(item,index) in unitList" :value="item" v-if="Number(item.search_area_width) < 600 && Number(item.search_area_width) > 300">
												<div class="p-1 armory-box battle-box">													
													<div class="armory-img-box gacha-item star3" :class="item.select ? '' : 'grayimg'" @click="joinTeam(item.unit_id,index,item.rarity,2)">
														<img :src="'/static/images/unit/icon_unit_'+ (Number(item.unit_id)+30) +'.png'" alt="">
													</div>
												</div>	
											</template>
										</div>
										<h3 class="item-title">後衛</h3>
										<div class="d-flex flex-wrap mb-3 justify-content-center">
											<template v-for="(item,index) in unitList" :value="item" v-if="Number(item.search_area_width) < 900 && Number(item.search_area_width) > 600">
												<div class="p-1 armory-box battle-box">													
													<div class="armory-img-box gacha-item star3" :class="item.select ? '' : 'grayimg'" @click="joinTeam(item.unit_id,index,item.rarity,2)">
														<img :src="'/static/images/unit/icon_unit_'+ (Number(item.unit_id)+30) +'.png'" alt="">
													</div>
												</div>	
											</template>
										</div>
										<div class="ok-box text-center step2">
											<div class="pcbtn mr-3" @click="nextStep(1)">上一步</div>
											<div class="pcbtn" @click="nextStep(3)">下一步</div>
										</div>
									</li>
									<li :style="step3BlockStyle" ref="setp3">
										<div class="row">
											<div class="col-12">
												<h2 class="text-center">‧進攻方</h2>
											</div>
											<div class="col-6">
												<div class="battle-data">
													<div class="title">
														總戰力
													</div>
													<div class="value">
														<input type="number" ref="AttackCP" id="AttackCP" class="form-control" value="0">
													</div>
												</div>
											</div>
											<div class="col-6">
												<div class="battle-data">
													<div class="title">
														星數
													</div>
													<div class="value">
														{{attackerStars}}
													</div>
												</div>
											</div>
											<div class="col-12 mt-3">
												<h2 class="text-center">‧調整星數</h2>
												<div class="d-flex flex-wrap mb-3 justify-content-center">
													<div class="p-1 armory-box battle-box" v-for="item in team1">
														<div class="armory-img-box gacha-item battle-item star3">
															<img class="unit-img" :src="'/static/images/unit/icon_unit_'+ (Number(item.unit_id)+30) +'.png'" alt="">
														</div>
														<div class="text-center">
															<div class="star-box">
																<span v-for="n in 6" class="rarity">
																	<img style="cursor: pointer" @click="changeStar(n,item)" src="/static/images/star.png" v-if="n <= Number(item.rarity) && n != 6">
																	<img style="cursor: pointer" @click="changeStar(n,item)" src="/static/images/star_pink.png" v-else-if="item.rarity == 6">
																	<img style="cursor: pointer" @click="changeStar(n,item)" src="/static/images/star_dark.png" v-else>
																</span>
															</div>
															<img class="mt-2" width="50" @click="addUnEq(item.hasUnEq,item);" :class="item.hasUnEq == 'false' ? 'grayimg' : ''" style="cursor: pointerl; width: 30px" src="/static/images/uneq.png">
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="row my-3">
											<div class="col-12 text-center">
												<h2 class="text-center">‧調整輸贏</h2>
												<div style="cursor: pointer">
													<img src="/static/images/win.png" @click="checkwl()" v-if="this.battleReportTeam.winlose">
													<img src="/static/images/lose.png" @click="checkwl()" v-else>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-12">
												<h2 class="text-center">‧防守方</h2>
											</div>
											<div class="col-6">
												<div class="battle-data">
													<div class="title">
														總戰力
													</div>
													<div class="value">
														<input type="number" ref="DefendCP" id="DefendCP" class="form-control" value="0">
													</div>
												</div>
											</div>
											<div class="col-6">
												<div class="battle-data">
													<div class="title">
														星數
													</div>
													<div class="value">
														{{defenderStars}}
													</div>
												</div>
											</div>
											<div class="col-12 mt-3">
												<h2 class="text-center">‧調整星數</h2>
												<div class="d-flex flex-wrap mb-3 justify-content-center">
													<div class="p-1 armory-box battle-box" v-for="item in team2" data-toggle="modal" data-target="#SelectCharacter">
														<div class="armory-img-box gacha-item battle-item star3">
															<img class="unit-img" :src="'/static/images/unit/icon_unit_'+ (Number(item.unit_id)+30) +'.png'" alt="">
														</div>
														<div class="text-center">
															<div class="star-box">
																<span v-for="n in 6" class="rarity">
																	<img style="cursor: pointer" @click="changeStar(n,item)" src="/static/images/star.png" v-if="n <= Number(item.rarity) && n != 6">
																	<img style="cursor: pointer" @click="changeStar(n,item)" src="/static/images/star_pink.png" v-else-if="item.rarity == 6">
																	<img style="cursor: pointer" @click="changeStar(n,item)" src="/static/images/star_dark.png" v-else>
																</span>
															</div>
															<img class="mt-2" @click="addUnEq(item.hasUnEq,item);" :class="item.hasUnEq == 'false' ? 'grayimg' : ''" style="cursor: pointer; width: 30px" src="/static/images/uneq.png">
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="row mb-2">
											<div class="col">
												<input type="text" ref="BattleNote" id="BattleNote" class="form-control text-left" placeholder="輸入備註">
											</div>
										</div>
										<div class="ok-box text-center step2">
											<div class="pcbtn mr-3" @click="nextStep(2)">上一步</div>
											<div class="pcbtn" data-dismiss="modal" @click="finish()">完成</div>
										</div>
									</li>
								</ol>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="item-box">
			<div class="mb-3" v-if="notSupport">
				<div class="alert alert-light" role="alert">
					抱歉，您的瀏覽器不支援儲存功能
				</div>
			</div>
			<div class="row mb-3">
				<div class="col-lg-12 col-md-12 col-12 mb-3">
					<div class="row mb-3">
						<div class="col">
							<div class="d-flex flex-nowrap armory-function">
								<button v-if="battleReportTeams.length < 100" type="button" class="pcbtn" data-toggle="modal" data-target="#AddCharacter">
									加入對戰紀錄
								</button>
								<button v-if="battleReportTeams.length > 0" class="pcbtn" @click="editTeam" v-bind:class="{ active: edit }">編輯隊伍</button>
								<button v-if="battleReportTeams.length > 0" class="pcbtn" @click="switchfilterEnable" v-bind:class="{ active: filterEnable }">篩選戰報</button>
								<button v-if="battleReportTeams.length > 0" class="pcbtn primary" @click="exportTeam">匯出連結</button>
								<button v-if="battleReportTeams.length > 0" class="pcbtn primary" @click="saveTeam">儲存隊伍</button>
								<button class="pcbtn danger" data-toggle="modal" data-target="#DeleteOk">刪除全部</button>
							</div>
						</div>
					</div>
					<h3 class="item-title">
						競技戰報(離線版)
					</h3>
					<div class="item-content battleReport-Box">
						<div v-if="filterEnable">
							<h3 class="item-title">
								<div class="row">
									<div class="col-lg-1 col-12">
										篩選
									</div>
									<div class="col-lg-2 col-12">
										<select class="form-control" style v-model="filterTeamType">
											<option selected="selected" value="attacker">進攻</option>
											<option value="defender">防守</option>
										</select>
									</div>
								</div>
							</h3>
							<div class="d-flex flex-wrap mb-3 battleReportFilter-box">
								<div v-for="item in allChara" class="m-1">									
									<img @click="filterChara(item);" width="50" class="unit-img" :src="'/static/images/unit/icon_unit_'+ (Number(item.unit_id)+30) +'.png'" alt="" :class="isFilterActive(item)">
								</div>
							</div>
						</div>
						<div class="row mb-3 report-item" v-for="(item,key) in filterTeams">
							<div class="col-12 mt-3" v-if="edit">
								<div class="d-flex align-items-center h-100">
									<button @click="delReport(item)" class="pcbtn danger">刪除</button>
								</div>
							</div>
							<div class="col-6">
								<div class="row">
									<div class="col-md-3 col-12">
										<img class="wlImg" width="110" src="/static/images/win.png" v-if="item.winlose">
										<img class="wlImg" width="110" src="/static/images/lose.png" v-else>
									</div>
									<div class="col-md-5 col-12 my-3">
										<div class="battle-data battle-report">
											<div class="title">
												總戰力
											</div>
											<div class="value">
												{{item.attacker.cp}}
											</div>
										</div>
									</div>
									<div class="col-md-4 my-3 col-12">
										<div class="battle-data battle-report">
											<div class="title">
												星數
											</div>
											<div class="value">
												{{countStar(item.attacker.team)}}
											</div>
										</div>
									</div>
								</div>
								<div class="d-flex flex-wrap mb-3 justify-content-center">
									<div class="p-1 armory-box battle-box" v-for="item in item.attacker.team" data-toggle="modal" data-target="#SelectCharacter">
										<div class="armory-img-box gacha-item battle-item star3">
											<img class="unit-img" :src="'/static/images/unit/icon_unit_'+ (Number(item.unit_id)+30) +'.png'" alt="">
											<div class="star-box" v-if="item.rarity != '6'">
												<span v-for="n in 5" class="rarity">
													<img src="/static/images/star.png" v-if="n <= Number(item.rarity)">
													<img src="/static/images/star_dark.png" v-else>
												</span>
											</div>
											<div class="star-box" v-else>
												<span class="rarity pink">
													<img src="/static/images/star_pink.png" style="width: 20px">
												</span>
											</div>
											<div class="uneq-box" v-if="item.hasUnEq == 'true'">
												<img width="10" src="/static/images/uneq.png">
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-6">
								<div class="row">
									<div class="col-md-3 col-12">
										<img class="wlImg" width="110" src="/static/images/win.png" v-if="!item.winlose">
										<img class="wlImg" width="110" src="/static/images/lose.png" v-else>
									</div>
									<div class="col-md-5 col-12 my-3">
										<div class="battle-data battle-report">
											<div class="title">
												總戰力
											</div>
											<div class="value">
												{{item.defender.cp}}
											</div>
										</div>
									</div>
									<div class="col-md-4 my-3 col-12">
										<div class="battle-data battle-report">
											<div class="title">
												星數
											</div>
											<div class="value">
												{{countStar(item.defender.team)}}
											</div>
										</div>
									</div>
								</div>
								<div class="d-flex flex-wrap mb-3 justify-content-center">
									<div class="p-1 armory-box battle-box" v-for="item in item.defender.team" data-toggle="modal" data-target="#SelectCharacter">
										<div class="armory-img-box gacha-item battle-item star3">
											<img class="unit-img" :src="'/static/images/unit/icon_unit_'+ (Number(item.unit_id)+30) +'.png'" alt="">
											<div class="star-box" v-if="item.rarity != '6'">
												<span v-for="n in 5" class="rarity">
													<img src="/static/images/star.png" v-if="n <= Number(item.rarity)">
													<img src="/static/images/star_dark.png" v-else>
												</span>
											</div>
											<div class="star-box" v-else>
												<span class="rarity pink">
													<img src="/static/images/star_pink.png" style="width: 20px">
												</span>
											</div>
											<div class="uneq-box" v-if="item.hasUnEq == 'true'">
												<img width="10" src="/static/images/uneq.png">
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12">
								<div class="battle-note">
									{{item.note}}
								</div>
							</div>
						</div>
					</div>
					<b>簡易個人戰報(離線版)</b><br />
					使用說明<br />
					1.加入隊伍/戰力/星數/輸贏 <br />
					2.儲存隊伍 <br />
					註: 儲存資訊只會記在當前瀏覽器<br />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Loading from "@/components/Loading.vue";
export default {
	name: 'BattleReport',
	props: ['clientWidth'],
	components: {
		Loading
	},
	data() {
		return {
			units: {},
			battleReportTeams: [],
			battleReportTeam: {
				"attacker": {
					"cp": 0,
					"wl": true,
					"team": [],
				},
				"defender": {
					"cp": 0,
					"wl": false,
					"team": [],
				},
				"winlose": true,
				"note": ""
			},
			exportNotice: "",
			notSupport: false,
			isLoading: false,
			step2ball: false,
			step3ball: false,
			step2BlockStyle: {},
			step3BlockStyle: {},
			stepLineStyle: {},
			step1BlockStyle: {},
			step2: {},
			objHeight: "",
			edit: false,
			filterEnable: false,
			filterCharaTeam: [],
			filterTeamType: "attacker"
		}
	},
	metaInfo: {
		title: '競技戰報',
	},
	methods: {
		filterChara: function(unit) {
			var units = this.filterCharaTeam;
			var unit_id = unit.unit_id;
			if (_.includes(units, unit_id)) {
				units = _.remove(units, function(n) {
					return n != unit_id;
				});
			} else {
				if (this.filterCharaTeam.length < 5) {
					units.push(unit_id);
				}
			}
			this.filterCharaTeam = units;
		},
		isFilterActive: function(item) {
			if (!_.includes(this.filterCharaTeam, item.unit_id)) {
				return "grayimg";
			}
			return;
		},
		switchfilterEnable: function() {
			var self = this;
			this.filterEnable = !this.filterEnable
			if (this.filterEnable == false) {
				self.filterCharaTeam = [];
			}
		},
		checkwl: function() {
			this.battleReportTeam.winlose = !this.battleReportTeam.winlose;
		},
		editTeam: function() {
			this.edit = !this.edit;
		},
		finish: function() {
			this.battleReportTeam.attacker.cp = Number(this.$refs.AttackCP.value);
			this.battleReportTeam.defender.cp = Number(this.$refs.DefendCP.value);
			this.battleReportTeam.attacker.team = _.orderBy(this.battleReportTeam.attacker.team, ['search_area_width'], ['desc']);
			this.battleReportTeam.defender.team = _.orderBy(this.battleReportTeam.defender.team, ['search_area_width'], ['desc']);
			this.battleReportTeam.note = this.$refs.BattleNote.value;
			this.battleReportTeams.push(this.battleReportTeam);
			this.initAdd();
		},
		initAdd: function() {
			var self = this;
			this.$refs.AttackCP.value = "";
			this.$refs.DefendCP.value = "";
			this.battleReportTeam = {
				"attacker": {
					"cp": 0,
					"wl": true,
					"team": [],
				},
				"defender": {
					"cp": 0,
					"wl": false,
					"team": [],
				},
				"winlose": true,
				"note": ""
			};
			this.step1BlockStyle = {
				display: "block",
				opacity: 1
			};
			this.step2BlockStyle = {
				display: "none",
				opacity: 0
			};
			this.step3BlockStyle = {
				display: "none",
				opacity: 0
			};
			this.stepLineStyle = {
				transform: 'scaleX(0.5)'
			};
			this.step2ball = false;
			this.step3ball = false;
			self.units = _.forEach(self.units, function(o) {
				o.select = false;
			});
		},
		nextStep: function(setp) {
			var self = this;
			if (setp == 1) {
				this.step1BlockStyle = {
					display: "block",
					opacity: 1
				};
				this.step2BlockStyle = {
					display: "none",
					opacity: 0
				};
				this.step3BlockStyle = {
					display: "none",
					opacity: 0
				};
				this.stepLineStyle = {
					transform: 'scaleX(0.5)'
				};
				var t1 = _.map(self.battleReportTeam["attacker"]["team"], 'unit_id');
				self.units = _.forEach(self.units, function(o) {
					if (_.includes(t1, o.unit_id)) {
						o.select = true;
						return;
					}
					o.select = false;
				});
				this.$forceUpdate();
				this.step2ball = false;
			} else if (setp == 2) {
				this.step1BlockStyle = {
					display: "none",
					opacity: 0
				};
				this.step2BlockStyle = {
					display: "block",
					opacity: 1
				};
				this.step3BlockStyle = {
					display: "none",
					opacity: 0
				};
				this.stepLineStyle = {
					transform: 'scaleX(0.5)'
				};
				this.step2ball = true;
				this.step3ball = false;
				var t2 = _.map(self.battleReportTeam["defender"]["team"], 'unit_id');
				self.units = _.forEach(self.units, function(o) {
					if (_.includes(t2, o.unit_id)) {
						o.select = true;
						return;
					}
					o.select = false;
				});
			} else if (setp == 3) {
				this.step1BlockStyle = {
					display: "none",
					opacity: 0
				};
				this.step2BlockStyle = {
					display: "none",
					opacity: 0
				};
				this.step3BlockStyle = {
					display: "block",
					opacity: 1
				};
				this.stepLineStyle = {
					transform: 'scaleX(1)'
				};
				this.step3ball = true;
				self.units = _.forEach(self.units, function(o) {
					o.select = false;
				});
			}

			self.step2ball = true;
		},
		selectCharacter: function(item) {
			this.selectUnit = item;
		},
		changeStar: function(n, unit) {
			unit.rarity = n;
		},
		addUnEq: function(hasUnEq, unit) {
			unit.hasUnEq = hasUnEq == "false" ? "true" : "false";
		},
		countStar: function(team) {
			var star = _.sum(_.map(team, "rarity"));
			return star;
		},
		changeRank: function() {
			var rankIndex = Number(this.selectUnit.promotion_level) - 1;
			this.selectUnit.promotion_level = this.selectUnit.promotion_level;
			_.forEach(this.selectUnit.eqList, function(value, key) {
				if (key < rankIndex) {
					for (var i = 1; i <= 6; i++) {
						value["equip_slot_" + i]["active"] = true;
					}
				} else {
					for (var i = 1; i <= 6; i++) {
						value["equip_slot_" + i]["active"] = false;
					}
				}
			});
		},
		delReport: function(item) {
			var team = _.remove(this.battleReportTeams, function(o) {
				return o != item;
			});
			this.battleReportTeams = team;
		},
		deleteUnit: function(value, team) {
			var self = this;
			var whichTeam = team == 1 ? "attacker" : "defender";
			var nowTeam = _.remove(this.battleReportTeam[whichTeam]["team"], function(o) {
				return o.unit_id != value;
			});
			this.battleReportTeam[whichTeam]["team"] = nowTeam;
			var reSelect = _.find(self.star3, ['id', value]);
			if (_.isEmpty(reSelect)) {
				var reSelect = _.find(self.star2, ['id', value]);
			}
			if (_.isEmpty(reSelect)) {
				var reSelect = _.find(self.star1, ['id', value]);
			}
			reSelect.select = false;
			_.forEach(nowTeam, function(o) {
				var reSelect = _.find(self.star3, ['id', o.unit_id]);
				if (_.isEmpty(reSelect)) {
					var reSelect = _.find(self.star2, ['id', o.unit_id]);
				}
				if (_.isEmpty(reSelect)) {
					var reSelect = _.find(self.star1, ['id', o.unit_id]);
				}
				reSelect.select = true;
			})
		},
		checkStar: function(value) {
			switch (value) {
				case "2":
					return "star2";
					break;
				case "3":
					return "star3";
					break;
				case "4":
					return "star3";
					break;
				case "5":
					return "star3";
					break;
				default:
					return;
			}
		},
		backward: function(n) {
			var now;
			switch (n) {
				case 1:
					now = 3;
					return now;
					break;
				case 3:
					now = 1;
					return now;
					break;
				default:
					return n;
			}
		},
		joinTeam: function(id, index, rarity, team) {
			var self = this;
			var whichTeam = team == 1 ? "attacker" : "defender";
			var battleReportTeam = this.battleReportTeam[whichTeam]["team"];
			if (_.find(battleReportTeam, ['unit_id', id])) {
				var nowTeam = _.remove(battleReportTeam, function(o) {
					return o.unit_id != id;
				});
				this.battleReportTeam[whichTeam]["team"] = nowTeam;
				this.$set(self.units[index], "select", false)
				return;
			}
			if (battleReportTeam.length >= 5) {
				return;
			}
			var thisUnit = _.find(self.$store.getters.getUnitData, ['unit_id', id]);
			var myUnit = new Object;
			myUnit["rarity"] = 5;
			myUnit["unit_id"] = thisUnit.unit_id;
			myUnit["search_area_width"] = thisUnit.search_area_width;
			myUnit["hasUnEq"] = "false";
			battleReportTeam.push(myUnit);
			this.battleReportTeam[whichTeam]["team"] = battleReportTeam;
			this.$set(self.units[index], "select", true)
			//self["units"][index].select = true;
		},
		getStarList: function(rarity) {
			var self = this;
			var newList = new Array;

			var list = _.forEach(self.$store.getters.getUnitData, function(value) {
				_.forEach(self.$store.getters.getCharaIdentity, function(o) {

					if (o.unit_id == value.unit_id && value.cutin_1 != "0") {
						var unit = {};
						unit["rarity"] = 3;
						unit["unit_id"] = o.unit_id;
						unit["search_area_width"] = value.search_area_width;
						unit["select"] = false;
						newList.push(unit);
					}
				});
			});
			self.units = _.orderBy(newList, ['search_area_width'], ['asc']);;
		},
		saveTeam: function() {
			var battleReportTeam = JSON.stringify(this.battleReportTeams);
			if (typeof(Storage) !== "undefined") {
				localStorage.setItem("battleReportTeams", battleReportTeam);
				$('#SaveOk').modal();
			} else {
				self.notSupport = true;
			}
		},
		loadTeam: function() {
			var self = this;
			var uuid = this.$route.query.s;

			function atou(str) {
				return decodeURIComponent(escape(window.atob(str)));
			}
			var myTeam = {};
			if (!_.isEmpty(uuid)) {
				var url = "/static/php/battleReportGet.php";
				var data = { "uuid": uuid };
				$.ajax({
					type: "POST",
					url: url,
					data: data,
					success: function(data) {
						myTeam = JSON.parse(atou(data));
						self.battleReportTeams = myTeam;
						history.pushState(null, "", location.href.split("?")[0]);
					},
					error: function(res) {
						self.exportNotice = "匯出失敗";
					}
				});
			} else {
				myTeam = JSON.parse(localStorage.getItem("battleReportTeams"));
				self.battleReportTeams = myTeam;
			}
		},
		deleteTeam: function() {
			var self = this;
			this.initAdd();
			this.battleReportTeams = [];
			_.forEach(self.star3, function(o) {
				o.select = false;
			});
			_.forEach(self.star2, function(o) {
				o.select = false;
			});
			_.forEach(self.star1, function(o) {
				o.select = false;
			});
			localStorage.removeItem("battleReportTeams");
		},
		showDetail: function() {
			this.eqDetail = !this.eqDetail;
		},
		showUnitEq: function() {
			this.fastSee = !this.fastSee;
		},
		b64EncodeUnicode: function(str) {
			return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
				function toSolidBytes(match, p1) {
					return String.fromCharCode('0x' + p1);
				}));
		},
		exportTeam: function() {
			var self = this;
			self.isLoading = true;
			if (!this.battleReportTeams) {
				this.exportNotice = "匯出失敗 沒有隊伍";
				return;
			}
			var uuid = this.uuid();
			this.exportNotice = uuid;
			var battleReportTeams = JSON.stringify(this.battleReportTeams);
			battleReportTeams = this.b64EncodeUnicode(battleReportTeams);
			var url = "/static/php/battleReportAdd.php";
			var data = { "battleList": battleReportTeams, "uuid": uuid };
			$.ajax({
				type: "POST",
				url: url,
				data: data,
				success: function(data) {
					var res = data.toString().trim();
					if (res == "200") {
						self.isLoading = false;
						self.exportNotice = "https://pcredivewiki.tw/BattleReport?s=" + uuid;
						$('#ExportOk').modal();
					}
				},
				error: function(res) {
					this.exportNotice = "匯出失敗";
				}
			});

		},
		uuid: function() {
			var d = Date.now();
			if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
				d += performance.now(); //use high-precision timer if available
			}
			return 'xxxxxxxx'.replace(/[xy]/g, function(c) {
				var r = (d + Math.random() * 16) % 16 | 0;
				d = Math.floor(d / 16);
				return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
			});
		},
	},
	created: function() {
		var self = this;
	},
	computed: {
		team1: function() {
			return _.orderBy(this.battleReportTeam.attacker.team, ['search_area_width'], ['desc']);
		},
		team2: function() {
			return _.orderBy(this.battleReportTeam.defender.team, ['search_area_width'], ['desc']);
		},
		unitList: function() {
			return this.units;
		},
		attackerStars: function() {
			var allstar = _.sum(_.map(this.battleReportTeam.attacker.team, "rarity"));
			return allstar;
		},
		defenderStars: function() {
			var allstar = _.sum(_.map(this.battleReportTeam.defender.team, "rarity"));
			return allstar;
		},
		allChara: function() {
			var self = this;
			var unit_data = new Array;
			_.forEach(self.$store.getters.getUnitData, function(value) {
				_.forEach(self.$store.getters.getCharaIdentity, function(o) {
					if (o.unit_id == value.unit_id && value.cutin_1 != "0") {
						unit_data.push(value);
					}
				});
			});
			unit_data = _.orderBy(unit_data, ['search_area_width'], ['asc']);
			return unit_data
		},
		filterTeams: function() {
			var self = this;
			var type = self.filterTeamType;
			var units = self.filterCharaTeam;
			if (_.isEmpty(units)) {
				return self.battleReportTeams;
			}
			var team = _.filter(self.battleReportTeams, function(o) {
				var ids = _.map(o[type].team, "unit_id");
				var diff = _.difference(ids, units).length;
				if ((5 - self.filterCharaTeam.length) == diff) {
					return o;
				}
			})
			return team;
		}
	},
	mounted: function() {
		var self = this;
		self.getStarList();
		if (typeof(Storage) === "undefined") {
			self.notSupport = true;
		}
		var uuid = self.$route.query.s;
		if (localStorage.getItem("battleReportTeams") != null || !_.isEmpty(uuid)) {
			self.isLoading = true;
			self.loadTeam();
			self.$nextTick(() => {
				self.isLoading = false;
			})
		}
	}
}
</script>
<style>
</style>